<template>
	<div>Agent 접속 실패</div>
</template>

<script>
import Cookies from 'js-cookie';
console.log(Cookies);
export default {
	data() {
		return {
			cookieUserId: '',
			cookieAutoLogin: 'N',
			cookieUserPw: ''
		};
	},

	mounted: function () {
		window.receiveDeviceInfo = this.receiveDeviceInfo;
		try {
			var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
			if (varUA.match('android') != null) {
				window.penchart.callChangeAddress();
			} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
				//IOS 일때 처리
				window.webkit.messageHandlers.callChangeAddress.postMessage('');
			}
		} catch (e) {
			alert(e);
		}
	},
	methods: {
		receiveDeviceInfo(json) {
			try {
				//디바이스 정보로 얻은것 api 도메인 세팅
				let url = `http://${json.ip}:${json.port}`;
				this.$axios.defaults.baseURL = url;
				this.$store.commit('deviceInfo', json);
				this.$router.push({
					name: '대기리스트'
				});
			} catch (e) {
				console.log(e);
			}
		}
	}
};
</script>

<style></style>
